import { defaultPm2PrintChunkClassName } from '@provider/print';
import { printSliderComponent } from './printer.to-jsx.js';

const printSliderComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: printSliderComponent(node, context)
  }];
};
const sliderComponentPaperPrinters = {
  "slider-component": printSliderComponentPaper
};

export { sliderComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
